import React, { useEffect, useState } from "react";
import { Backdrop, Button, FormFieldSet, LogoLoader, showToast, useFormHandler } from "../../../../components";
import { updateLeadJob } from "../../../../redux/slices/bdmjobs/bdmjobsApi";

const EditJobModal = ({ job, onCancel, onSuccess }) => {
    const [loading, setLoading] = useState(false);
    const validationRules = {
        jobTitle: {
            type: "text",
            required: true,
        },
        location: {
            type: "object",
            required: true,
        },
        jobUrl: {
            type: "text",
            required: true,
        },
    };

    const initialFormData = {
        jobTitle: "",
        // location: "",
        location: {
            uiValue: null,   // for UI
            address: null,   // for backend
        },
        jobUrl: "",
        applicantsApplied: "",
        jobPoster: "",
        designation: "",
        status: 1,
    };

    const handleUpdate = async () => {
        if (!validateAllFields()) return;

        try {
            setLoading(true);
            const res = await updateLeadJob({
                coll: "LeadJob",
                uiid: job.uiid,
                payload: [
                    {
                        type: "SET",
                        value: {
                            jobTitle: formData.jobTitle,
                            location: formData.location?.address,
                            jobUrl: formData.jobUrl,
                            noOfApplicants: formData.applicantsApplied,
                            posterName: formData.jobPoster,
                            posterTitle: formData.posterTitle,
                            status: formData.status,
                        },
                    },
                ],
            });

            if (res?.data) {
                showToast("Job updated successfully", "success");
                if(onSuccess) onSuccess();
            }
        } catch (err) {
            console.error("Update failed", err);
            showToast("Failed to update job", "error");
        } finally {
            setLoading(false);
        }
    };

    const { formData, errors, handleChange, validateAllFields, setFormData } =
        useFormHandler(initialFormData, validationRules);

    // useEffect(() => {
    //     if (!job) return;

    //     setFormData({
    //         jobTitle: job.jobTitle || "",
    //         location: job.location || "",
    //         jobUrl: job.url || "",
    //         applicantsApplied: job.noOfApplicants || "",
    //         jobPoster: job.jobPoster || "",
    //         posterTitle: job.posterTitle || "",
    //         status: job.status || 1,
    //     });
    // }, [job]);
    useEffect(() => {
        if (!job) return;

        let uiValue = null;
        let address = null;

        if (job.location && typeof job.location === "object") {
            const { city, state, country, zipCode } = job.location;

            if (city && state) {
                const combined = `${city} - ${state}`;
                uiValue = {
                    label: combined,
                    value: combined,
                };
            } else if (state) {
                uiValue = {
                    label: state,
                    value: state,
                };
            }

            address = {
                city: city || null,
                state: state || null,
                country: country || null,
                zipCode: zipCode || null,
            };
        }

        else if (typeof job.location === "string") {
            const parts = job.location.split(",").map(v => v.trim());

            if (parts.length === 2) {
                const [city, state] = parts;
                const combined = `${city} - ${state}`;

                uiValue = {
                    label: combined,
                    value: combined,
                };

                address = { city, state };
            } else if (parts.length === 1) {
                uiValue = {
                    label: parts[0],
                    value: parts[0],
                };

                address = { state: parts[0] };
            }
        }

        setFormData({
            jobTitle: job.jobTitle || "",
            location: {
                uiValue,
                address,
            },
            jobUrl: job.jobUrl || "",
            applicantsApplied: job.noOfApplicants || "",
            jobPoster: job.posterName || "",
            posterTitle: job.posterTitle || "",
            status: job.status || 1,
        });
    }, [job]);

    return (
        <div className="flex flex-col gap-5 p-4 sm:p-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
                <FormFieldSet
                    type="text"
                    title="Job Title"
                    placeholder="Enter"
                    shadow={true}
                    value={formData.jobTitle}
                    onChange={(value) => handleChange("jobTitle", value)}
                    error={errors.jobTitle}
                    required
                />

                <FormFieldSet
                    type="atscitiesState"
                    title="Location"
                    placeholder="Enter"
                    shadow={true}
                    // value={formData.location}
                    value={formData.location.uiValue}
                    // onChange={(value) => handleChange("location", value)}
                    onChange={(option) => {
                        if (!option) {
                            handleChange("location", { uiValue: null, address: null });
                            return;
                        }

                        const value = option.value || "";
                        let address = { city: null, state: null };

                        if (value.includes("-")) {
                            const [city, state] = value.split("-").map(v => v.trim());
                            address.city = city;
                            address.state = state;
                        } else {
                            address.state = value;
                        }

                        handleChange("location", {
                            uiValue: option,
                            address,
                        });
                    }}
                    error={errors.location}
                    required
                    parentValue={{ country: "6807640e7ecb9f7d31314b7e" }}
                    showSearch
                />

                <FormFieldSet
                    type="text"
                    title="Job URL"
                    shadow={true}
                    placeholder="Enter"
                    value={formData.jobUrl}
                    onChange={(value) => handleChange("jobUrl", value)}
                    error={errors.jobUrl}
                    required
                />

                <FormFieldSet
                    type="text"
                    title="No. of Applicants Applied"
                    placeholder="Enter"
                    shadow={true}
                    value={formData.applicantsApplied}
                    onChange={(value) => handleChange("applicantsApplied", value)}
                    error={errors.applicantsApplied}
                />

                <FormFieldSet
                    type="text"
                    title="Job Poster name"
                    placeholder="Enter"
                    shadow={true}
                    value={formData.jobPoster}
                    onChange={(value) => handleChange("jobPoster", value)}
                    error={errors.jobPoster}
                />

                <FormFieldSet
                    type="text"
                    title="Poster Title"
                    placeholder="Enter"
                    shadow={true}
                    value={formData.posterTitle}
                    onChange={(value) => handleChange("posterTitle", value)}
                    error={errors.posterTitle}
                    className="sm:col-span-2 lg:col-span-1"
                />
                <FormFieldSet
                    type="select"
                    title="Status"
                    size="md"
                    options={[
                        { label: "Active", value: 1 },
                        { label: "Followup", value: 2 },
                        { label: "Declined", value: 3 },
                        { label: "Positive Response", value: 4 },
                        { label: "Hold by Client", value: 5 },
                        { label: "On Hold", value: 6 },
                        { label: "Interview L1", value: 7 },
                        { label: "Interview L2", value: 8 },
                        { label: "Interview L3", value: 9 },
                        { label: "Priority", value: 10 },
                        { label: "Filled", value: 11 },
                        { label: "Closed", value: 12 },
                        { label: "Agreement Sent", value: 13 },
                        { label: "Agreement Accepted", value: 14 },
                    ]}
                    showSearch
                    value={formData?.status}
                    onChange={(value) => handleChange("status", value)}
                />
            </div>

            <div className="flex flex-col-reverse sm:flex-row justify-end items-center gap-3 mt-2">
                <Button
                    variant="outlined"
                    title="Cancel"
                    color="black"
                    onClick={() => onCancel()}
                    className="w-full sm:w-auto"
                />
                <Button
                    title="Save"
                    variant="contained"
                    color="primary"
                    className="w-full sm:w-auto"
                    onClick={handleUpdate}
                />
            </div>
            <Backdrop isOpen={loading}>
                <LogoLoader />
            </Backdrop>
        </div>
    );
};

export default EditJobModal;